
























































































import { AddNewsModal } from '@/components/admin-panel/news';
import { DeleteNewsModal } from '@/components/admin-panel/news';
import { News } from '@/models/dashboard';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewsManagementView',
  components: {
    AddNewsModal,
    DeleteNewsModal,
  },
  data() {
    return {
      loader: {
        isNewsListPending: false,
      },
      newsToDelete: undefined as unknown as News,
      editedNews: undefined as unknown as News,
    };
  },
  async created() {
    this.loader.isNewsListPending = true;

    try {
      await this.$store.dispatch(Actions.news.fetchAdminNews);
    } finally {
      this.loader.isNewsListPending = false;
    }
  },
  computed: {
    newsList(): News[] {
      return typedStore(this).state.news.newsList;
    },
    areMoreItemsAvailable(): boolean {
      return this.newsList.length < typedStore(this).state.news.pagination.totalCount && this.newsList.length > 0;
    },
  },
   methods: {
    goToAddNews() {
      this.$router.push({ name: 'news-edit'});
    },
    getNewsTime(dateTime: string): string {
      return (this as any).$options.filters.formattedDate(dateTime);
    },
    addNews() {
      this.editedNews = undefined as unknown as News;
      this.$bvModal.show('add-news-modal');
    },
    editNews(news: News) {
      this.editedNews = news;
      this.$bvModal.show('add-news-modal');
    },
    deleteNews(news: News) {
      this.newsToDelete = news;
      this.$bvModal.show('delete-news-modal');
    },
    async fetchNews() {
      this.loader.isNewsListPending = true;

      try {
        await this.$store.dispatch(Actions.news.fetchAdminNews);
      } finally {
        this.loader.isNewsListPending = false;
      }
    },
    async loadMoreElements() {
      this.loader.isNewsListPending = true;

      try {
        await this.$store.dispatch(Actions.news.fetchMoreAdminNews);
      } finally {
        this.loader.isNewsListPending = false;
      }
    },
  },
});
